import { useState, useRef } from "react";
import "./editorialForms.css";

export default function GifForm({ data, onChange }) {
  const [searchQuery, setSearchQuery] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({ 
          ...data, 
          gifFile: file, 
          gifFileName: file.name,
          gifPreview: reader.result 
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const popularCategories = [
    { id: "reactions", name: "Reacoes", emoji: "😂" },
    { id: "happy", name: "Feliz", emoji: "😊" },
    { id: "sad", name: "Triste", emoji: "😢" },
    { id: "love", name: "Amor", emoji: "❤️" },
    { id: "angry", name: "Raiva", emoji: "😠" },
    { id: "celebrate", name: "Celebrar", emoji: "🎉" },
    { id: "thumbsup", name: "Positivo", emoji: "👍" },
    { id: "facepalm", name: "Facepalm", emoji: "🤦" },
  ];

  return (
    <div className="editorial_form gif_form">
      <div className="editorial_form_section">
        <label>Fonte do GIF</label>
        <select
          value={data?.source || "giphy"}
          onChange={(e) => onChange({ ...data, source: e.target.value })}
        >
          <option value="giphy">GIPHY</option>
          <option value="tenor">Tenor</option>
          <option value="custom">Upload personalizado</option>
        </select>
      </div>

      {data?.source !== "custom" && (
        <>
          <div className="editorial_form_section">            <label>
              Upload do GIF <span className="required">*</span>
            </label>
            <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/gif,.gif"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              {data?.gifPreview ? (
                <div className="file_selected gif_preview">
                  <img src={data.gifPreview} alt="Preview" style={{ maxWidth: "200px", maxHeight: "200px" }} />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onChange({ ...data, gifFile: null, gifFileName: null, gifPreview: null });
                    }}
                    className="file_remove_btn"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="file_placeholder">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                  </svg>
                  <p>Clique para fazer upload do GIF</p>
                  <span>Apenas arquivos .gif</span>
                </div>
              )}
            </div>
          </div>

          <div className="editorial_form_section">            <label>Buscar GIF</label>
            <div className="gif_search_container">
              <input
                type="text"
                placeholder="Buscar GIFs..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="gif_search_btn" type="button">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
              </button>
            </div>
          </div>

          <div className="editorial_form_section">
            <label>Categorias Populares</label>
            <div className="gif_categories">
              {popularCategories.map((cat) => (
                <div
                  key={cat.id}
                  className={`gif_category_item ${
                    data?.category === cat.id ? "selected" : ""
                  }`}
                  onClick={() => {
                    onChange({ ...data, category: cat.id });
                    setSearchQuery(cat.name);
                  }}
                >
                  <span className="cat_emoji">{cat.emoji}</span>
                  <span className="cat_name">{cat.name}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {data?.source === "custom" && (
        <div className="editorial_form_section">
          <label>Titulo do GIF</label>
          <input
            type="text"
            placeholder="De um titulo ao seu GIF..."
            value={data?.title || ""}
            onChange={(e) => onChange({ ...data, title: e.target.value })}
            maxLength={100}
          />
        </div>
      )}

      <div className="editorial_form_section">
        <label>URL do GIF (opcional)</label>
        <input
          type="url"
          placeholder="https://giphy.com/..."
          value={data?.originalUrl || ""}
          onChange={(e) => onChange({ ...data, originalUrl: e.target.value })}
        />
        <span className="editorial_form_hint">
          Cole o link do GIF do GIPHY ou Tenor
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Opcoes</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="autoplay"
            checked={data?.autoplay !== false}
            onChange={(e) =>
              onChange({ ...data, autoplay: e.target.checked })
            }
          />
          <label htmlFor="autoplay">Reproduzir automaticamente</label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="loop"
            checked={data?.loop !== false}
            onChange={(e) => onChange({ ...data, loop: e.target.checked })}
          />
          <label htmlFor="loop">Loop infinito</label>
        </div>
      </div>

      <div className="editorial_form_tip gif_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z" />
        </svg>
        <span>
          GIFs sao limitados a 15MB. Para melhor qualidade, use GIFs com
          resolucao de ate 480px de largura.
        </span>
      </div>
    </div>
  );
}
